import axios from "axios";
import Config from "../../config";
import RefreshTokenHandler from './refresh-token';

export const getGeneralLedgerReport = async (
  ledger_code,
  fund_code,
  start_date,
  end_date
) => {
  const email = sessionStorage.getItem("email");
  const token = sessionStorage.getItem("token");
  const url = `${Config.baseUrl}/transaction/get-ledger-by-code-and-date?email=${email}&ledger_code=${ledger_code}&start_date=${start_date}&end_date=${end_date}&fund_code=${fund_code}`;
  try {
    const result: any = await axios.get(url, {
      headers: { Authorization: token },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getGeneralLedgerReport(ledger_code, fund_code, start_date, end_date);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

export const getDailyBalance = async (start_date, ledger_code, fund_code) => {
  const token = sessionStorage.getItem("token");
  const email = sessionStorage.getItem("email");
  const url = `${Config.baseUrl}/transaction/get-daily-balance-by-fund-and-ledger?email=${email}&fund_code=${fund_code}&date=${start_date}&ledger_code=${ledger_code}`;
  try {
    const result: any = await axios.get(url, {
      headers: { Authorization: token },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDailyBalance(start_date, ledger_code, fund_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
